import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MusicCollection } from '@model/musicCollection';


@Component({
    selector: 'tun-search-music-collection-large-button-view',
    templateUrl: './search-music-collection-large-button-view.component.html',
    styleUrl: './search-music-collection-large-button-view.component.scss',
    standalone: false
})
export class SearchMusicCollectionLargeButtonViewComponent {
  @Input() musicCollection: MusicCollection;

  @Input() hexColor: string = "#F6836A";

  @Output() showDetails = new EventEmitter<MusicCollection>();

  private whitePercentage = 0.1;

  private blendWithWhite(colorCode: number){
    return Math.floor((colorCode * (1- this.whitePercentage) + 255 * this.whitePercentage))
  }

  private hexToRgb(hex) {
    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
      return r + r + g + g + b + b;
    });

    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
      r: parseInt(result[1], 16),
      g: parseInt(result[2], 16),
      b: parseInt(result[3], 16)
    } : null;
  }

  private componentToHex(c) {
    var hex = c.toString(16);
    return hex.length == 1 ? "0" + hex : hex;
  }

  private rgbToHex(r: number, g:number, b: number) {
    return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
  }

  private get lighterColor(){
    let colorCodes = this.hexToRgb(this.hexColor);
    return this.rgbToHex(
      this.blendWithWhite(colorCodes.r),
      this.blendWithWhite(colorCodes.g),
      this.blendWithWhite(colorCodes.b)
    )
  }

  get background(){
    let bg =  'linear-gradient(0.25turn, {0}, {1})'.replace('{0}', this.hexColor).replace('{1}', this.lighterColor);
    return bg;
  }

    constructor(

    ){

    }

    public onShowDetails(){
      this.showDetails.emit(this.musicCollection);
    }
}
